var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { classNames } from "@bookingcom/bui-core/utilities/classNames";
import { useFlyoutContext } from "./Flyout.context.js";
import styles from "@bookingcom/bui-core/css/_base/Flyout.module.css";
var FlyoutTrigger = function (props) {
    var children = props.children, className = props.className, display = props.display;
    var _a = useFlyoutContext(), id = _a.id, flyoutTriggerRef = _a.flyoutTriggerRef, triggerType = _a.triggerType, handleFocus = _a.handleFocus, handleBlur = _a.handleBlur, handleMouseEnter = _a.handleMouseEnter, handleMouseLeave = _a.handleMouseLeave, handleMouseMove = _a.handleMouseMove, handleClick = _a.handleClick, flyout = _a.flyout, focusTrapped = _a.focusTrapped;
    var isFocus = triggerType === "focus";
    var isHover = triggerType === "hover";
    var isClick = triggerType === "click";
    var a11yAttributes = focusTrapped
        ? { "aria-controls": id }
        : { "aria-describedby": id };
    var childrenAttributes = __assign(__assign({}, (flyout.active ? a11yAttributes : {})), { "aria-expanded": flyout.active });
    if (isHover || isFocus) {
        childrenAttributes.onFocus = handleFocus;
        childrenAttributes.onBlur = handleBlur;
    }
    if (isHover) {
        childrenAttributes.onMouseMove = handleMouseMove;
        childrenAttributes.onMouseEnter = handleMouseEnter;
        childrenAttributes.onMouseLeave = handleMouseLeave;
    }
    if (isClick || isFocus) {
        childrenAttributes.onClick = handleClick;
    }
    var rootClassNames = classNames(styles.root, className, display && styles["root--display-".concat(display)]);
    return (React.createElement("span", { ref: flyoutTriggerRef, className: rootClassNames }, children(childrenAttributes)));
};
export default FlyoutTrigger;
